// noinspection JSUnusedLocalSymbols

import { SessionContextType } from 'supertokens-auth-react/lib/build/recipe/session';
import { AccessTokenPayload } from '../Types/Varios.ts';

function simularSuperAdmin() {
    return {
        loading: false,
        accessTokenPayload: {
            is_sadmin: true,
            legacy_id: '8',
        } as AccessTokenPayload,
        invalidClaims: [],
        doesSessionExist: true,
        userId: 'PENDIENTE',
    };
}

function simularUsuarioNormal(cuenta_id: string) {
    return {
        loading: false,
        accessTokenPayload: {
            is_sadmin: false,
            legacy_id: '8',
            roles: [
                {
                    cuenta_id: cuenta_id,
                    cid: '01H9KN2WX24RW0ZTXA8GER318S',
                    rol: 'ADMIN',
                },
            ],
        } as AccessTokenPayload,
        invalidClaims: [],
        doesSessionExist: true,
        userId: 'PENDIENTE',
    };
}

function simularNoLogueado(): SessionContextType {
    return {
        doesSessionExist: false,
        loading: false,
        accessTokenPayload: undefined,
        userId: '',
        invalidClaims: [],
    };
}

export const useSessionContextMock: () => SessionContextType = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('superAdmin')) return simularSuperAdmin();
    const cuenta_id = params.get('cuenta_id');
    if (cuenta_id) return simularUsuarioNormal(cuenta_id);
    return simularNoLogueado();
};
